<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-form" ref="form" @submit.prevent="onSubmit($event)">
      <!--begin::Form-->
      <form class="kt-form">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fas fa-user-secret"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">รหัสสินค้า:</label>
                  <span class="form-control-plaintext">{{
                    PrdMaterialCode
                  }}</span>
                </div>
              </div>

              <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                                <div class="form-group">
                                    <label class="label">ชื่อสินค้า(SAP):</label>
                                    <span class="form-control-plaintext">{{PrdProductDesc_th}}</span>
                                </div>
              </div>-->

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">ชื่อสินค้า:</label>
                  <span class="form-control-plaintext">{{
                    PrdProductDesc_th2
                  }}</span>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">แบรนด์สินค้า:</label>
                  <span class="form-control-plaintext">{{
                    PrdProductBrandDesc
                  }}</span>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">หมวดหมู่:</label>
                  <span class="form-control-plaintext">{{
                    PrdProductGroupDesc
                  }}</span>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">ประเภทสินค้า:</label>
                  <span class="form-control-plaintext">{{
                    PrdProductTypeDesc
                  }}</span>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">หน่วยนับ:</label>
                  <span class="form-control-plaintext">{{ PrdBaseUnit }}</span>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">ราคากลาง:</label>
                  <span class="form-control-plaintext">{{
                    PrdInitialPrice | currency("฿", 2)
                  }}</span>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">ราคาเฉลี่ย:</label>
                  <span class="form-control-plaintext">{{
                    PrdAvgPrice | currency("฿", 2)
                  }}</span>
                </div>
              </div>

              <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">Quantity:</label>
                  <span class="form-control-plaintext">{{PrdQty | currency('', 0)}}</span>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">Available Quantity:</label>
                  <span class="form-control-plaintext">{{PrdAvQty | currency('', 0)}}</span>
                </div>
              </div> -->
            </div>
            <!-- Begin:Picture element -->
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label
                    >รูปภาพ:<span
                      class="text-sm text-danger"
                      style="font-size:small"
                    >
                      (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน
                      10Mb.)</span
                    ></label
                  >
                  <div class="row" id="container-img">
                    <div
                      v-for="element in imgDownload"
                      :key="element.pictureId"
                      v-if="element.isLoaded"
                      class="col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap"
                      :id="element.pictureId"
                    >
                      <img
                        :src="element.downloadUrl"
                        :id="element.pictureId"
                        class="img-plant -avatar js-avatar-me img-thumbnail card-img-top"
                        @error="handleImageError(element)"
                        @load="handleImageLoad(element)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End:Picture element -->
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label>รหัสบาร์โค้ด:</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        id="PrdHasBarcode"
                        name="PrdHasBarcode"
                        v-model="PrdHasBarcode"
                        type="checkbox"
                        class="form-check-input"
                        disabled="disabled"
                      />
                      มีข้อมูล BARCODE
                      <span></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label>สินค้าสำหรับใบHold(รับคืน):</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        id="PrdIsForJobHold"
                        name="PrdIsForJobHold"
                        v-model="PrdIsForJobHold"
                        type="checkbox"
                        class="form-check-input"
                        disabled="disabled"
                      />
                      เปิดใช้งาน
                      <span></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label>หัวจ่าย:</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        id="PrdIsBarButler"
                        name="PrdIsBarButler"
                        v-model="PrdIsBarButler"
                        type="checkbox"
                        class="form-check-input"
                        disabled="disabled"
                      />
                      มีหัวจ่ายในตัว
                      <span></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">จำนวนหัวจ่าย:</label>
                  <span class="form-control-plaintext">{{
                    PrdBarButlerQty
                  }}</span>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">ประเภทอะไหล่งาน PM:</label>
                  <span class="form-control-plaintext">{{ PrdPMSpare }}</span>
                </div>
              </div>

              

            </div>

            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label>ตั้งค่าสินค้าสำหรับใช้งานช่างซ่อมบำรุง:</label>
                  
                  <div class="form-check">
                      <label class="form-check-label kt-checkbox">
                          <input id="isSpareOrMachine"
                                 name="isSpareOrMachine"
                                 v-model="isSpareOrMachine"
                                 type="checkbox"
                                 class="form-check-input"
                                 disabled="disabled" />
                          ประเภทเครื่องเบียร์สด/อุปกรณ์ ใช้สำหรับใบงานประเมินสภาพและใบงานซ่อมอุปกรณ์เบียร์สด
                          <span></span>

                      </label>
                      <label class="text-danger" style="margin-left:30px;">*การเลือกประเภทมีผลต่อการแสดงแบบฟอร์มในใบงาน</label>
                      <span class="form-control-plaintext" style="margin-left:30px;">{{ QiSubProductTypeDesc }}</span>

                  </div>

                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        id="IsQiSpare"
                        name="IsQiSpare"
                        v-model="IsQiSpare"
                        type="checkbox"
                        class="form-check-input"
                        disabled="disabled"
                      />
                      อะไหล่ช่างซ่อมบำรุง
                      <span></span>
                    </label>
                  </div>

                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        id="IsSupplierSpare"
                        name="IsSupplierSpare"
                        v-model="IsSupplierSpare"
                        type="checkbox"
                        class="form-check-input"
                        disabled="disabled"
                      />
                      อะไหล่ซัพพลายเออร์
                      <span></span>
                    </label>
                  </div>

                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-xl-3">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        id="PrdInActiveStatus"
                        name="PrdInActiveStatus"
                        v-model="PrdInActiveStatus"
                        type="checkbox"
                        class="form-check-input"
                        disabled="disabled"
                      />
                      เปิดใช้งาน
                      <span></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="$router.go(-1)"
          >
            <i class="la la-close"></i> ย้อนกลับ
          </button>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: function() {
    var self = this;
    return {
      PrdMaterialCode: null,
      PrdProductDesc_th: null,
      PrdProductDesc_th2: null,
      PrdProductBrandDesc: null,
      PrdProductTypeDesc: null,
      PrdProductGroupDesc: null,
      PrdProductBrandId: null,
      PrdProductTypeId: null,
      PrdProductGroupId: null,
      PrdBaseUnit: null,
      PrdInActiveStatus: null,
      PrdIsBarButler: null,
      PrdBarButlerQty: null,
      uuid: null,
      imgDownload: [],
      PrdInitialPrice: null,
      PrdAvgPrice: null,
      PrdQty: null,
      PrdAvQty: null,
      PrdIsForJobHold: null,
      PrdHasBarcode: null,
      PrdPMSpare: null,
      isSpareOrMachine : false,
      IsQiSpare : false,
      IsQiMachine : false,
      IsQiEquipment : false,
      IsSupplierSpare : false, 
      QiSubProductTypeDesc : null
    };
  },
  methods: {
    handleImageError(image) {
      image.isLoaded = false;
    },
    handleImageLoad(image) {
      image.isLoaded = true;
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();
    self.uuid = this._uid;

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    // set validation rules
    $(this.$refs.form).validate({
      rules: {},
      messages: {},
    });

    axios
      .get("/Api/Product/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          self.PrdMaterialCode = response.data.materialCode;
          self.PrdProductDesc_th = response.data.materialDesc_th;
          self.PrdProductDesc_th2 = response.data.materialDesc_th2;
          self.PrdProductBrandId = response.data.materialBrand;
          self.PrdProductBrandDesc = response.data.materialBrandDesc;
          self.PrdProductGroupId = response.data.materialGrp;
          self.PrdProductGroupDesc = response.data.materialGrpDesc;
          self.PrdProductTypeId = response.data.materialType;
          self.PrdProductTypeDesc = response.data.materialTypeDesc;
          self.PrdBaseUnit = response.data.baseUnit;
          self.PrdInitialPrice = response.data.initialPrice;
          self.PrdAvgPrice = response.data.avgPrice;
          self.PrdInActiveStatus = !response.data.inActiveStatus;
          self.PrdQty = response.data.qty;
          self.PrdAvQty = response.data.availableQty;
          self.PrdIsForJobHold = response.data.isForJobHold;
          self.PrdHasBarcode = response.data.hasBarcode;
          self.PrdIsBarButler = response.data.isBarButler;
          self.PrdBarButlerQty = response.data.barButlerQty;
          self.PrdPMSpare = response.data.pmSpareName;

          self.IsQiSpare = response.data.isQiSpare;
          self.IsQiMachine = response.data.isQiMachine;
          self.IsQiEquipment = response.data.isQiEquipment;
          self.IsSupplierSpare = response.data.isSupplierSpare; 
          self.QiSubProductTypeDesc = response.data.qiSubProductTypeDesc;

          if (self.IsQiEquipment || self.IsQiMachine)
              self.isSpareOrMachine = true;
          else
              self.isSpareOrMachine = false;


          self.imgDownload = response.data.pictures.map((element) => ({
            pictureId: element.pictureId,
            downloadUrl: element.urlImg,
            isLoaded: true,
          }));

        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลสินค้าคุณเลือก", "warning");
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลสินค้าได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  },
};
</script>



// WEBPACK FOOTER //
// App/Components/Master/Product/ProductDetail.vue